<script setup lang="ts">
defineProps<{
  items: { description: string; author: string }[];
}>();
</script>

<template>
  <UCarousel v-slot="{ item }" :autoplay="{ delay: 5000 }" :items="items">
    <div class="quote m-4 bg-white rounded-lg border shadow-sm transition flex flex-col gap-3 p-6">
      <p class="text-xl italic text-default text-center">
        {{ item.description }}
      </p>
      <p class="font-bold text-muted text-right">
        — {{ item.author }}
      </p>
    </div>
  </UCarousel>
</template>
